module.exports = __webpack_public_path__ + "media/images/success-img/layer-2-978c56685cbc12d959f22d0620933d4f.png";